import { isLocal } from '@/utils/baseUrl';
import { doPost } from '@/utils/request';

let domain = 'lcscListUrl';
if (isLocal) {
  domain = 'https://devlist.szlcsc.com';
}

// 获取配套连接器、同系列sku
export function loadProductSeries(body) {
  return doPost(domain, `/product/series`, body);
}
